import * as React from 'react';

interface FExpandProps {
  className?: string;
  style?: React.CSSProperties;

  onClick?(): void;
}

/** 下拉初始态：与 FSelect2 关闭态一致，10×6 朝下三角 */
function FExpand({ className, style, onClick }: FExpandProps) {
  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path fill="currentColor" d="M2 4h10L7 10 2 4z" />
    </svg>
  );
}

export default FExpand;
